/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';

/**
 * 
 * @export
 * @interface AttestationBase
 */
export interface AttestationBase {
    /**
     * 
     * @type {string}
     * @memberof AttestationBase
     */
    challenge_id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof AttestationBase
     */
    challenge_type: ChallengeType;
}



/**
 * Check if a given object implements the AttestationBase interface.
 */
export function instanceOfAttestationBase(value: object): value is AttestationBase {
    if (!('challenge_id' in value) || value['challenge_id'] === undefined) return false;
    if (!('challenge_type' in value) || value['challenge_type'] === undefined) return false;
    return true;
}

export function AttestationBaseFromJSON(json: any): AttestationBase {
    return AttestationBaseFromJSONTyped(json, false);
}

export function AttestationBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttestationBase {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'],
        'challenge_type': ChallengeTypeFromJSON(json['challenge_type']),
    };
}

export function AttestationBaseToJSON(json: any): AttestationBase {
    return AttestationBaseToJSONTyped(json, false);
}

export function AttestationBaseToJSONTyped(value?: AttestationBase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge_id': value['challenge_id'],
        'challenge_type': ChallengeTypeToJSON(value['challenge_type']),
    };
}

